import { getOrgFindById } from '@/api/home'

const state = {
    orgId: '',
    orgName: '',
    orgInfo: {},
    // 搜索
    keywordSearch: '',
    isSearch: false,
}

const mutations = {
    SET_ORGID: (state, id) => {
        state.orgId = id
    },
    SET_ORGINFO: (state, data) => {
        state.orgInfo = data
    },
    SET_ORGNAME: (state, name) => {
        state.orgName = name
    },

    SET_KEYWORDSEARCH: (state, a) => {
        state.keywordSearch = a
    },
    SET_ISSEARCH: (state, isSearch) => {
        state.isSearch = isSearch
    },
}

const actions = {
    // get info
    getInfo({ commit, state }) {
        return new Promise((resolve, reject) => {
            getOrgFindById(state.orgId).then(response => {
                const { data } = response

                if (!data) {
                    return reject('没有机构信息')
                }

                commit('SET_ORGINFO', data)
                commit('SET_ORGNAME', data.name)
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js